module.exports = function() {
  return new Worker(__webpack_public_path__ + "fd424e8b7b8fc56b7c75.worker.js");
};